const SVGComponent = ({ mainfill, ...props }) => (
  <svg
    width={14}
    height={10}
    viewBox='0 0 14 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.2422 1.028C13.6309 1.37517 13.6654 1.97294 13.3195 2.36341L7.71339 8.69245C7.54333 8.88439 7.30265 8.9989 7.04651 9.00893C6.79038 9.01896 6.54144 8.92413 6.35689 8.74602L0.312359 2.84071C-0.0628996 2.47871 -0.0743572 1.88014 0.285896 1.50316C0.646546 1.12615 1.2426 1.11438 1.61784 1.47599L6.95706 6.70045L11.912 1.10622C12.2579 0.715752 12.8535 0.680836 13.2422 1.028Z'
      fill={mainfill || 'currentColor'}
    />
  </svg>
);

export default SVGComponent;
